export default __webpack_public_path__ + "static/media/070_boost.hevc.688eea75.mp4";